/**
 * Shared swiper configuration presets for BaseSwiper.
 *
 * Each preset defines the common option combinations used across the app.
 * Consumers can spread a preset and override individual fields as needed.
 */

/** Horizontal auto-width scroll — slides size themselves from content. */
export const AUTO_SCROLL = {
  slidesPerView: 'auto',
  pagination: false,
};

/** Single-item carousel with navigation arrows (e.g. church-updates content carousel). */
export const SINGLE_ITEM = {
  slidesPerView: 1,
  centeredSlides: true,
  grabCursor: true,
  hasNavigation: true,
  pagination: false,
  gap: 0,
};

/** Library / resource card carousel. */
export const LIBRARY = {
  slidesPerView: 'auto',
  grabCursor: true,
  hasNavigation: true,
  pagination: false,
};

/** Common responsive breakpoints for grid-like carousels (MyGiving, etc.). */
export const RESPONSIVE_BREAKPOINTS = {
  641: { slidesPerView: 2, centeredSlides: false },
  1024: { slidesPerView: 3, centeredSlides: false },
  1366: { slidesPerView: 4, centeredSlides: false },
};
